<div class="list-wrapper">
  <div class="list">
    <div class="item" *ngFor="let starter of textList(); let idx = index; let last = last; trackBy: trackByIndex">
      <u-input
        #inputItem
        class="item-input"
        [model]="starter"
        [sizeElement]="'small'"
        [label]="label"
        [placeholder]="placeholder"
        [stateElement]="state === 'disabled' ? 'disabled' : 'regular'"
        [inputFocus]="last && focusLastInput"
        (onEnter)="$event.stopPropagation()"
        (onClear)="onRemoveItem(idx); $event?.stopPropagation()"
        (onChange)="onChangeItem($event, idx)"
        [clearIconBehavior]="'search'"
      ></u-input>
    </div>
  </div>
  @if (state !== 'readonly') {
    <u-button
      [versionNumber]="2"
      [label]="'Add'"
      [styleType]="'text'"
      [typeElement]="'primary'"
      [stateElement]="textList().length >= limit || disableAddBtn() || state === 'disabled' ? 'disabled' : 'regular'"
      [sizeElement]="'large'"
      fontIcon="mac-maximize-plus"
      (onClick)="onAddItem()"
    >
    </u-button>
  }
</div>
